import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { routes } from '@routes';

// UI
import { Icon, IconNames } from '@components/icon';
type Link = {
  href: string | VoidFunction;
  name: string;
  target?: string;
  rel?: string;
};
const socialMediaLinks: Array<Link & {
  icon: IconNames;
}> = [{
  name: 'Facebook',
  href: routes.facebook,
  icon: IconNames.FACEBOOK_F,
  rel: 'nofollow',
  target: '_blank'
}, {
  name: 'Instagram',
  href: routes.instagram,
  icon: IconNames.INSTAGRAM,
  rel: 'nofollow',
  target: '_blank'
}, {
  name: 'TikTok',
  href: routes.tiktok,
  icon: IconNames.TIKTOK,
  rel: 'nofollow',
  target: '_blank'
}, {
  name: 'Pinterest',
  href: routes.pinterest,
  icon: IconNames.PINTEREST_P,
  rel: 'nofollow',
  target: '_blank'
}, {
  name: 'LinkedIn',
  href: routes.linkedIn,
  icon: IconNames.LINKEDIN_IN,
  rel: 'nofollow',
  target: '_blank'
}, {
  name: 'YouTube',
  href: routes.youtube,
  icon: IconNames.YOUTUBE,
  rel: 'nofollow',
  target: '_blank'
}];
interface FooterSocialProps {
  showNewsletter?: boolean;
  children?: React.ReactNode;
}
export const FooterSocial: React.FC<FooterSocialProps> = t0 => {
  const $ = _c(7);
  const {
    showNewsletter: t1,
    children
  } = t0;
  const showNewsletter = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h3 className="mb-4 text-lg font-medium text-secondary-main">Stay in touch</h3>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-[4px] sm:max-w-[300px]">{t2}<div className="flex justify-between space-x-1 max-w-xs">{socialMediaLinks.map(_temp)}</div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== showNewsletter) {
    t4 = showNewsletter && <div className="mt-8">{children}</div>;
    $[2] = children;
    $[3] = showNewsletter;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="grid grid-cols-1 flex-col pt-8 sm:pt-12 lg:flex-row lg:w-full lg:grid-cols-[450px_1fr] lg:items-end lg:pt-4">{t3}{t4}</div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
function _temp(item) {
  return <a key={item.name} href={typeof item.href === "string" ? item.href : undefined} target={item.target} rel={item.rel} className="flex h-10 w-10 items-center justify-center rounded-full bg-white transition-opacity hover:opacity-80 hover:cursor-pointer"><Icon name={item.icon} size="xl" className="text-primary-main" /></a>;
}